<script setup>
import { Link } from '@inertiajs/vue3';
import imageHelper from '@/Helpers/image_helper.js';

const { getImage } = imageHelper.methods;

const props = defineProps({
    id: {
        type: Number,
        required: true,
    },
    bg: {
        type: String,
        required: true
    },
    icon: {
        type: String,
        required: true
    },
    title: {
        type: String,
        required: true
    },
    description: {
        type: String,
        required: true
    },
    routeName: {
        type: String,
        default: ''
    }
});

</script>
<template>
    <article
        class="relative w-full min-h-[340px] md:h-[430px] bg-cover bg-center shadow-lg transition-transform duration-500 ease-in-out"
        :style="{ backgroundImage: `url(${getImage(props.bg)})` }">
        <Link class=" w-full h-full" :href="route(props.routeName, {id})">
        <div class="absolute inset-0 bg-gradient-to-b from-black/10 via-black-500/20 to-black/90"></div>
        <div class="absolute top-[34%] w-full flex flex-col justify-center items-center gap-y-3">
            <div
                class="block p-4 md:p-5 rounded-full bg-grayArticleColor/80 transition-transform duration-500 ease-in-out">
                <img class="h-8 md:h-10" :src="getImage(props.icon)" alt="Icon Services">
            </div>
            <h1 class="text-title-content-sub text-white">{{ props.title }}</h1>
            <p class="text-description text-white text-center w-5/6 md:line-clamp-4">
                {{ props.description }}
            </p>
        </div>
        </Link>
    </article>
</template>

<style scoped>
@media (min-width: 641px) {
    a:hover {
        transform: translateY(-10px);
    }

    a:hover div:first-child {
        transform: scaleX(-1);
    }
}
</style>
